import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getSalaryTotalList, getSalaryDetailList, exportSalaryTotalList, exportSalaryDetailList, sendSalaryNotice } from '@/services/salary';
import { downloadFile as _downloadFile } from '@/services/system';
import SalarySendModal from './SalarySendModal.vue';
export default {
  name: 'SalaryImportDetailModal',
  components: {
    SalarySendModal: SalarySendModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    sendTimeDisplay: function sendTimeDisplay() {
      if (this.detailData.sendStatus === 0) {
        return '-';
      } else {
        // 从工资总表明细中找到第一个sendStatus为1的记录的lastModTime
        var sentRecord = this.mainData.find(function (item) {
          return item.sendStatus === 1;
        });
        return sentRecord ? sentRecord.lastModTime : '-';
      }
    }
  },
  data: function data() {
    return {
      detailData: {},
      // 发送工资条模态框显示状态
      sendModalVisible: false,
      // 当前操作的记录
      currentSendRecord: {},
      // 主表数据
      mainData: [],
      mainPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      mainLoading: false,
      // 明细表数据
      detailDataList: [],
      detailPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      detailLoading: false,
      // 搜索条件
      mainSearchTerm: '',
      detailSearchTerm: '',
      // 搜索框输入值
      mainSearchValue: '',
      detailSearchValue: '',
      // 主表明细列
      mainColumns: [{
        title: '序号',
        dataIndex: 'id',
        key: 'id'
      }, {
        title: '姓名',
        dataIndex: 'name',
        key: 'name'
      }, {
        title: '身份证号码',
        dataIndex: 'idcard',
        key: 'idcard'
      }, {
        title: '岗位',
        dataIndex: 'post',
        key: 'post'
      }, {
        title: '档案工资',
        dataIndex: 'archivalSalary',
        key: 'archivalSalary'
      }, {
        title: '校龄工资',
        dataIndex: 'schoolAgeSalary',
        key: 'schoolAgeSalary'
      }, {
        title: '基础性绩效',
        dataIndex: 'basicPerformance',
        key: 'basicPerformance'
      }, {
        title: '奖励性绩效',
        dataIndex: 'rewardPerformance',
        key: 'rewardPerformance'
      }, {
        title: '加班工资',
        dataIndex: 'overtimeSalary',
        key: 'overtimeSalary'
      }, {
        title: '应发工资合计',
        dataIndex: 'totalShouldPay',
        key: 'totalShouldPay'
      }, {
        title: '养老保险',
        dataIndex: 'pensionInsurance',
        key: 'pensionInsurance'
      }, {
        title: '医疗保险',
        dataIndex: 'medicalInsurance',
        key: 'medicalInsurance'
      }, {
        title: '失业保险',
        dataIndex: 'unemploymentInsurance',
        key: 'unemploymentInsurance'
      }, {
        title: '住房公积金',
        dataIndex: 'housingFund',
        key: 'housingFund'
      }, {
        title: '养保金补扣',
        dataIndex: 'pensionSupplement',
        key: 'pensionSupplement'
      }, {
        title: '医保金补扣',
        dataIndex: 'medicalSupplement',
        key: 'medicalSupplement'
      }, {
        title: '失保金补扣',
        dataIndex: 'unemploymentSupplement',
        key: 'unemploymentSupplement'
      }, {
        title: '预扣个税',
        dataIndex: 'prepaidTax',
        key: 'prepaidTax'
      }, {
        title: '扣工资',
        dataIndex: 'deductSalary',
        key: 'deductSalary'
      }, {
        title: '扣其他1',
        dataIndex: 'deductOther1',
        key: 'deductOther1'
      }, {
        title: '扣其他2',
        dataIndex: 'deductOther2',
        key: 'deductOther2'
      }, {
        title: '扣其他3',
        dataIndex: 'deductOther3',
        key: 'deductOther3'
      }, {
        title: '扣其他4',
        dataIndex: 'deductOther4',
        key: 'deductOther4'
      }, {
        title: '扣其他5',
        dataIndex: 'deductOther5',
        key: 'deductOther5'
      }, {
        title: '扣其他6',
        dataIndex: 'deductOther6',
        key: 'deductOther6'
      }, {
        title: '扣其他7',
        dataIndex: 'deductOther7',
        key: 'deductOther7'
      }, {
        title: '扣其他8',
        dataIndex: 'deductOther8',
        key: 'deductOther8'
      }, {
        title: '扣其他9',
        dataIndex: 'deductOther9',
        key: 'deductOther9'
      }, {
        title: '扣其他10',
        dataIndex: 'deductOther10',
        key: 'deductOther10'
      }, {
        title: '实发金额',
        dataIndex: 'actualAmount',
        key: 'actualAmount'
      }],
      // 明细列 - 奖励性绩效明细
      detailColumns: [{
        title: '姓名',
        dataIndex: 'name',
        key: 'name'
      }, {
        title: '身份证号',
        dataIndex: 'idcard',
        key: 'idcard'
      }, {
        title: '岗位',
        dataIndex: 'post',
        key: 'post'
      }, {
        title: '名师工作室津贴',
        dataIndex: 'studioAllowance',
        key: 'studioAllowance'
      }, {
        title: '校医安全值周金额',
        dataIndex: 'medicalWeekSecurity',
        key: 'medicalWeekSecurity'
      }, {
        title: '周末校医安全值周金额',
        dataIndex: 'medicalWeekendSecurity',
        key: 'medicalWeekendSecurity'
      }, {
        title: '年级主任津贴',
        dataIndex: 'gradeDirectorAllowance',
        key: 'gradeDirectorAllowance'
      }, {
        title: '高中部年级副主任津贴',
        dataIndex: 'seniorGradeDeputyAllowance',
        key: 'seniorGradeDeputyAllowance'
      }, {
        title: '教研组长津贴',
        dataIndex: 'teachingResearchLeaderAllowance',
        key: 'teachingResearchLeaderAllowance'
      }, {
        title: '备课组长津贴',
        dataIndex: 'lessonPreparationLeaderAllowance',
        key: 'lessonPreparationLeaderAllowance'
      }, {
        title: '副备课组长津贴',
        dataIndex: 'lessonPreparationDeputyAllowance',
        key: 'lessonPreparationDeputyAllowance'
      }, {
        title: '团委津贴(副)',
        dataIndex: 'youthLeagueAllowance',
        key: 'youthLeagueAllowance'
      }, {
        title: '高中部团总支书记',
        dataIndex: 'seniorYouthBranchLeaderAllowance',
        key: 'seniorYouthBranchLeaderAllowance'
      }, {
        title: '德育备课津贴',
        dataIndex: 'moralLessonAllowance',
        key: 'moralLessonAllowance'
      }, {
        title: '干事津贴',
        dataIndex: 'clerkAllowance',
        key: 'clerkAllowance'
      }, {
        title: '职务津贴',
        dataIndex: 'positionAllowance',
        key: 'positionAllowance'
      }, {
        title: '班主任津贴',
        dataIndex: 'headTeacherAllowance',
        key: 'headTeacherAllowance'
      }, {
        title: '平时兴趣特长课金额',
        dataIndex: 'interestClassAmount',
        key: 'interestClassAmount'
      }, {
        title: '艺体、心理社团课金额(收费)',
        dataIndex: 'paidClubAmount',
        key: 'paidClubAmount'
      }, {
        title: '艺体、心理社团课金额(不收费)',
        dataIndex: 'freeClubAmount',
        key: 'freeClubAmount'
      }, {
        title: '心理讲座金额',
        dataIndex: 'psychologyLectureAmount',
        key: 'psychologyLectureAmount'
      }, {
        title: '职员岗位绩效',
        dataIndex: 'staffPerformance',
        key: 'staffPerformance'
      }, {
        title: '周内正课金额',
        dataIndex: 'weekdayClassAmount',
        key: 'weekdayClassAmount'
      }, {
        title: '周末正课金额',
        dataIndex: 'weekendClassAmount',
        key: 'weekendClassAmount'
      }, {
        title: '初中周末艺体专业团队训练课金额',
        dataIndex: 'juniorArtsTeamTraining',
        key: 'juniorArtsTeamTraining'
      }, {
        title: '代班主任金额',
        dataIndex: 'substituteHeadTeacherAmount',
        key: 'substituteHeadTeacherAmount'
      }, {
        title: '周内早自习金额',
        dataIndex: 'weekdayMorningStudy',
        key: 'weekdayMorningStudy'
      }, {
        title: '周末早自习金额',
        dataIndex: 'weekendMorningStudy',
        key: 'weekendMorningStudy'
      }, {
        title: '青蓝工程津贴',
        dataIndex: 'mentoringProgramAllowance',
        key: 'mentoringProgramAllowance'
      }, {
        title: '晚自习金额',
        dataIndex: 'eveningStudyAmount',
        key: 'eveningStudyAmount'
      }, {
        title: '竞赛课金额',
        dataIndex: 'competitionClassAmount',
        key: 'competitionClassAmount'
      }, {
        title: '卓越名师研修津贴',
        dataIndex: 'outstandingTeacherAllowance',
        key: 'outstandingTeacherAllowance'
      }, {
        title: '科技类竞赛课金额',
        dataIndex: 'scienceCompetitionAmount',
        key: 'scienceCompetitionAmount'
      }, {
        title: '直升班津贴',
        dataIndex: 'directAdmissionAllowance',
        key: 'directAdmissionAllowance'
      }, {
        title: '监考金额(当月考试)',
        dataIndex: 'examInvigilationPayed',
        key: 'examInvigilationPayed'
      }, {
        title: '监考金额(当月未考)',
        dataIndex: 'examInvigilationUnpayed',
        key: 'examInvigilationUnpayed'
      }, {
        title: '小组长津贴',
        dataIndex: 'groupLeaderAllowance',
        key: 'groupLeaderAllowance'
      }, {
        title: '平时教务值周金额',
        dataIndex: 'weekdayTeachingDutyAmount',
        key: 'weekdayTeachingDutyAmount'
      }, {
        title: '早自习金额(周内)',
        dataIndex: 'weekdayMorningStudyAmount',
        key: 'weekdayMorningStudyAmount'
      }, {
        title: '周末教务值周金额',
        dataIndex: 'weekendTeachingDutyAmount',
        key: 'weekendTeachingDutyAmount'
      }, {
        title: '政教值周金额',
        dataIndex: 'moralEducationDutyAmount',
        key: 'moralEducationDutyAmount'
      }, {
        title: '周末政教值周金额',
        dataIndex: 'weekendMoralEducationDuty',
        key: 'weekendMoralEducationDuty'
      }, {
        title: '托管金额',
        dataIndex: 'trusteeshipAmount',
        key: 'trusteeshipAmount'
      }, {
        title: '补发绵中绩效金额',
        dataIndex: 'backPayAmount',
        key: 'backPayAmount'
      },
      // Note: combining two fields as "补发绵中绩效金额"
      {
        title: '通讯补贴',
        dataIndex: 'communicationSubsidy',
        key: 'communicationSubsidy'
      }, {
        title: '晚自习金额',
        dataIndex: 'eveningStudy',
        key: 'eveningStudy'
      }, {
        title: '周末正课金额',
        dataIndex: 'weekendClass',
        key: 'weekendClass'
      }, {
        title: '早自习金额(周末)',
        dataIndex: 'weekendMorningStudyAmount',
        key: 'weekendMorningStudyAmount'
      }, {
        title: '高中部周末晚自习请假扣除',
        dataIndex: 'leaveDeduction',
        key: 'leaveDeduction'
      },
      // Combining the deduction with senior weekend evening study
      {
        title: '司机工资',
        dataIndex: 'driverSalary',
        key: 'driverSalary'
      }, {
        title: '其他1',
        dataIndex: 'other1',
        key: 'other1'
      }, {
        title: '其他2',
        dataIndex: 'other2',
        key: 'other2'
      }, {
        title: '其他3',
        dataIndex: 'other3',
        key: 'other3'
      }, {
        title: '其他4',
        dataIndex: 'other4',
        key: 'other4'
      }, {
        title: '其他5',
        dataIndex: 'other5',
        key: 'other5'
      }, {
        title: '其他6',
        dataIndex: 'other6',
        key: 'other6'
      }, {
        title: '其他7',
        dataIndex: 'other7',
        key: 'other7'
      }, {
        title: '合计',
        dataIndex: 'totalAmount',
        key: 'totalAmount'
      }]
    };
  },
  watch: {
    visible: function visible(newVal) {
      if (newVal) {
        this.loadData();
      }
    }
  },
  methods: {
    loadData: function loadData() {
      // 加载导入详情
      this.detailData = _objectSpread({}, this.record);
      // 加载主表数据
      this.loadMainData();
      // 加载明细表数据
      this.loadDetailData();
    },
    loadMainData: function loadMainData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this.mainLoading = true;
              _context.p = 1;
              params = {
                recordId: _this.record.id,
                search: _this.mainSearchTerm,
                pageNum: _this.mainPagination.current,
                pageSize: _this.mainPagination.pageSize
              };
              _context.n = 2;
              return getSalaryTotalList(params);
            case 2:
              response = _context.v;
              if (response.data.code === 200) {
                _this.mainData = response.data.data.records || [];
                _this.mainPagination.total = response.data.data.total || 0;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              _context.p = 4;
              _this.mainLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    },
    loadDetailData: function loadDetailData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _this2.detailLoading = true;
              _context2.p = 1;
              params = {
                recordId: _this2.record.id,
                search: _this2.detailSearchTerm,
                pageNum: _this2.detailPagination.current,
                pageSize: _this2.detailPagination.pageSize
              };
              _context2.n = 2;
              return getSalaryDetailList(params);
            case 2:
              response = _context2.v;
              if (response.data.code === 200) {
                _this2.detailDataList = response.data.data.records || [];
                _this2.detailPagination.total = response.data.data.total || 0;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
            case 4:
              _context2.p = 4;
              _this2.detailLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }))();
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    refreshMainData: function refreshMainData() {
      this.mainPagination.current = 1;
      this.loadMainData();
    },
    refreshDetailData: function refreshDetailData() {
      this.detailPagination.current = 1;
      this.loadDetailData();
    },
    exportMainData: function exportMainData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, blob, url, link, _this3$$message, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                recordId: _this3.record.id,
                search: _this3.mainSearchTerm
              };
              _context3.n = 1;
              return exportSalaryTotalList(params);
            case 1:
              blob = _context3.v;
              // Create a download link for the file
              url = window.URL.createObjectURL(blob);
              link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', "".concat(_this3.detailData.salaryTitle || '工资', "_\u5DE5\u8D44\u603B\u8868\u660E\u7EC6.xlsx"));
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              (_this3$$message = _this3.$message) === null || _this3$$message === void 0 || _this3$$message.error('导出工资总表明细失败');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    exportDetailData: function exportDetailData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params, blob, url, link, _this4$$message, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                recordId: _this4.record.id,
                search: _this4.detailSearchTerm
              };
              _context4.n = 1;
              return exportSalaryDetailList(params);
            case 1:
              blob = _context4.v;
              // Create a download link for the file
              url = window.URL.createObjectURL(blob);
              link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', "".concat(_this4.detailData.salaryTitle || '工资', "_\u5956\u52B1\u6027\u7EE9\u6548\u660E\u7EC6.xlsx"));
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              (_this4$$message = _this4.$message) === null || _this4$$message === void 0 || _this4$$message.error('导出奖励性绩效明细失败');
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }))();
    },
    downloadFile: function downloadFile(relativePath, fileName) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var params, _this5$$message, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                relativePath: relativePath
              };
              _context5.n = 1;
              return _downloadFile(params);
            case 1:
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              (_this5$$message = _this5.$message) === null || _this5$$message === void 0 || _this5$$message.error('下载文件失败');
            case 3:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 2]]);
      }))();
    },
    handleSearchMain: function handleSearchMain() {
      // 直接使用v-model绑定的变量
      this.mainSearchTerm = this.mainSearchValue;
      this.mainPagination.current = 1;
      this.loadMainData();
    },
    handleMainSearchChange: function handleMainSearchChange() {
      // 直接使用v-model绑定的变量
      this.mainSearchTerm = this.mainSearchValue || '';
      this.mainPagination.current = 1;
      this.loadMainData();
    },
    handleSearchDetail: function handleSearchDetail() {
      // 直接使用v-model绑定的变量
      this.detailSearchTerm = this.detailSearchValue;
      this.detailPagination.current = 1;
      this.loadDetailData();
    },
    handleDetailSearchChange: function handleDetailSearchChange() {
      // 直接使用v-model绑定的变量
      this.detailSearchTerm = this.detailSearchValue || '';
      this.detailPagination.current = 1;
      this.loadDetailData();
    },
    handleMainTableChange: function handleMainTableChange(pagination) {
      this.mainPagination = _objectSpread(_objectSpread({}, this.mainPagination), pagination);
      this.loadMainData();
    },
    handleDetailTableChange: function handleDetailTableChange(pagination) {
      this.detailPagination = _objectSpread(_objectSpread({}, this.detailPagination), pagination);
      this.loadDetailData();
    },
    getImportStatusText: function getImportStatusText(status) {
      switch (status) {
        case 0:
          return '失败';
        case 1:
          return '成功';
        case 2:
          return '处理中';
        default:
          return '未知';
      }
    },
    getImportStatusColor: function getImportStatusColor(status) {
      switch (status) {
        case 0:
          return 'red';
        case 1:
          return 'green';
        case 2:
          return 'orange';
        default:
          return 'gray';
      }
    },
    getSendStatusText: function getSendStatusText(status) {
      switch (status) {
        case 0:
          return '未发送';
        case 1:
          return '已发送';
        case 2:
          return '发送中';
        default:
          return '未知';
      }
    },
    getSendStatusColor: function getSendStatusColor(status) {
      switch (status) {
        case 0:
          return 'orange';
        case 1:
          return 'blue';
        case 2:
          return 'gold';
        default:
          return 'gray';
      }
    },
    // 发送工资条
    sendSalarySlip: function sendSalarySlip() {
      // 检查导入状态，如果是失败则不执行操作
      if (this.detailData.importStatus === 0) {
        this.$message.warning('无法发送失败的导入记录，请先解决导入问题');
        return;
      }
      // 显示发送工资条模态框
      this.showSendModal(this.detailData);
    },
    // 显示发送工资条模态框
    showSendModal: function showSendModal(record) {
      this.currentSendRecord = record;
      this.sendModalVisible = true;
    },
    // 处理发送工资条确认
    handleConfirmSend: function handleConfirmSend(params) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var response, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return sendSalaryNotice(params);
            case 1:
              response = _context6.v;
              if (response.data.code === 200) {
                _this6.$message.success(response.data.message || '工资条发送成功');
                // 刷新数据
                _this6.loadData();
              } else {
                _this6.$message.error(response.data.message || '工资条发送失败');
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              _this6.$message.error('发送工资条失败，请稍后重试');
            case 3:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 2]]);
      }))();
    },
    // 处理发送模态框取消
    handleSendModalCancel: function handleSendModalCancel() {
      this.sendModalVisible = false;
      this.currentSendRecord = {};
    }
  }
};